var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "one-column-layout",
    {
      attrs: { title: _vm.PRODUCT_NAME2, fixed: false },
      scopedSlots: _vm._u([
        {
          key: "top",
          fn: function() {
            return [_c("CustomTourHeader")]
          },
          proxy: true
        },
        {
          key: "header",
          fn: function() {
            return [_c("Header")]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      [
        _vm.resultMessage
          ? _c(
              "div",
              {
                staticClass: "p-2 bg-white mb-2 text-center",
                attrs: { id: "partiOra" }
              },
              [
                _c("span", { staticClass: "text-primary" }, [
                  _vm._v(_vm._s(_vm.resultMessage))
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _c(
            "div",
            {
              staticClass: "row no-gutters mb-3",
              style: _vm.isMobile ? "margin-top: 130px" : ""
            },
            [
              _c("div", { staticClass: "col-7 col-md-9 filter-panel" }, [
                _c("div", { staticClass: "filter-control" }, [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-content-between",
                      on: { click: _vm.onOpenCloseFilter }
                    },
                    [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "text-secondary",
                            attrs: { href: "javascript:void(0)" }
                          },
                          [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.isMobile ? "Filtra" : "Filtra risultati"
                                )
                              )
                            ]),
                            _c("span", [_vm._v(" | " + _vm._s(_vm.counter))])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-sm btn-secondary mr-2",
                            on: { click: _vm.onResetFilter }
                          },
                          [_vm._v("reset")]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        mouseleave: function($event) {
                          _vm.openFilter = false
                        }
                      }
                    },
                    [
                      _c("DropdownFilterTour", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.openFilter,
                            expression: "openFilter"
                          }
                        ],
                        attrs: {
                          "min-price": _vm.minPrice,
                          "max-price": _vm.maxPrice,
                          value: _vm.filter
                        },
                        on: { change: _vm.onChangeFilter }
                      })
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pl-3 col-5 col-md-3" },
                [
                  _c("CustomOrderSelect", {
                    staticClass: "lg gray",
                    attrs: { list: _vm.orders, value: _vm.order },
                    on: { change: _vm.onChangeOrder }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.tours, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  ref: "listRef",
                  refInFor: true,
                  staticClass: "mb-3"
                },
                [
                  _c("HorizzontalItemTour", {
                    attrs: { aereoporti: _vm.aereoporti, value: item },
                    on: { select: _vm.onSelect }
                  })
                ],
                1
              )
            }),
            0
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3325a16f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3325a16f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/TourSelection.vue
// module id = null
// module chunks = 